export const mutationUserForceDelete = `
  mutation userForceDelete($id: [ID!]!) {
    userForceDelete(
      id: $id
    ) {
      id
    }
  }
`;